import { Component, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BuiltUpAreaDetailsComponent } from './details/builtup-area-details.component';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { ReportsService } from 'app/modules/admin/transactions/inwards/reports.service';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { BaseRespone } from 'app/core/models/common.response';
import { Observable, Subject } from 'rxjs';
import { BuiltUpAreaService } from './builtup-area.service';
import { BuiltUpArea } from './builtup-area.types';
import { map, take, takeUntil } from 'rxjs/operators';
import { InwardReport } from 'app/modules/admin/transactions/inwards/reports.types';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
    selector: 'app-builtup-area',
    templateUrl: './builtup-area.component.html',
    styleUrls: ['./builtup-area.component.scss']
})
export class BuiltUpAreaComponent implements OnInit {


    @Input() report: InwardReport;
    @Input() reportId: number;
    @Input() reportType: string;
    selection = new SelectionModel<BuiltUpArea>(true, []);
    total: number = 0.00;
    //@Output() LandAreaTotle : EventEmitter<number> = new EventEmitter();

    totalSuperBuiltUp: number = 0.00;

    selectedBuiltUpArea: BuiltUpArea;
    selectedIds: number[] = [];
    isAllSelectedCheckBox: boolean = false

    builtUpAreas$: Observable<BuiltUpArea[]>;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    constructor(private _matDialog: MatDialog,
        private _matDialogRef: MatDialogRef<BuiltUpAreaComponent>,
        private _fuseConfirmationService: FuseConfirmationService,
        private _builtUpAreaService: BuiltUpAreaService,
        private _alertMessageService: AlertMessageService,
        @Inject(MAT_DIALOG_DATA)
        private _data: {
            report: InwardReport;
            reportId: number;
            reportType: string;
        }
    ) { 
            this.report = _data.report;
            this.reportType = _data.reportType;
            this.reportId = _data.reportId;
        }

    ngOnInit(): void {

        this._builtUpAreaService.getBuiltUpAreas(this.reportId).subscribe((res) => {
            this.calculateBuiltUpAreaLandsTotal();
        });

        this.builtUpAreas$ = this._builtUpAreaService.builtUpAreas$.pipe(map((data) => {
            data?.sort((a, b) => {
                return a.id < b.id ? -1 : 1;
            });
            return data;
        }));


        // Get the contact
        this._builtUpAreaService.builtUpArea$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((contact: BuiltUpArea) => {

                // Update the selected contact
                this.selectedBuiltUpArea = contact;

                // Mark for check
                //this._changeDetectorRef.markForCheck();
            });


        // if (this.builtUpAreas.subscribe(re).length > 0) {
        //     this.calculateSiteMeasurementsTotal();
        // }

    }

    new(): void {
        let orderIndex = 0;
        this.builtUpAreas$.subscribe(result => {
            orderIndex = result.length + 1;
        });

        this._matDialog.open(BuiltUpAreaDetailsComponent, {
            autoFocus: false,
            data: {
                builtUpArea: {
                    orderIndex: orderIndex,
                    areaAsPer: '',
                    area: '',
                    reportId: this.reportId

                },
                reportType: this.reportType
            },
        }).afterClosed().subscribe(() => {});
    }

    edit(builtUpArea: BuiltUpArea): void {
        this._matDialog.open(BuiltUpAreaDetailsComponent, {
            autoFocus: false,
            data: {
                builtUpArea: builtUpArea,
                reportType: this.reportType
            },
        }).afterClosed()
            .subscribe((response: BaseRespone<BuiltUpArea>) => {
            });
    }


    /**
    * Delete the selected product using the form data
    */
    delete(id: number): void {
        // Open the confirmation dialog
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete BuiltUpArea',
            message: 'Are you sure you want to remove? This action cannot be undone!',
            actions: {
                confirm: {
                    label: 'Delete'
                }
            }
        });

        // Subscribe to the confirmation dialog closed action
        confirmation.afterClosed().subscribe((result) => {
            // If the confirm button pressed...
            if (result === 'confirmed') {
                //Delete the product on the server
                this._builtUpAreaService.deleteBuiltUpArea(id).subscribe((res) => {
                    if (res.isSuccess) {
                        this._alertMessageService.success("BuiltUpArea deleted successfully");
                    }
                    else {
                        this._alertMessageService.error(res.errors.join('\n'));
                    }
                });
            }
        });
    }

    async deleteSelectedRows() {
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete All BuiltUpArea',
            message: 'Are you sure you want to remove? This action cannot be undone!',
            actions: {
                confirm: {
                    label: 'Delete'
                }
            }
        });

        const result = await confirmation.afterClosed().toPromise();

        if (result === 'confirmed') {
            const ids = this.selection.selected.map(item => item.id);
            const res = await this._builtUpAreaService.deleteAllBuiltUpArea(ids).toPromise();

            if (res.isSuccess) {
                this._alertMessageService.success("BuiltUpArea all deleted successfully");
                this.selection.clear();
                this.builtUpAreas$.subscribe()
            } else {
                this._alertMessageService.error(res.errors.join('\n'));
            }
        }
    }
    /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    calculateBuiltUpAreaLandsTotal(): void {

        this._builtUpAreaService.builtUpAreas$.subscribe(res => {

            let total = res.reduce((sum, current) => sum + current.area, 0);
            this.total = total;
            

            /////
            // this.report.valuationBuiltUp = total;
            //     this.report.siteBuiltUp = res.reduce((sum, current) => sum + current.total, 0);
            //    // this.totalSuperBuiltUp = res.reduce((sum, current) => sum + current.siteSuperBuiltUp, 0);
        })
    }

    updateCheckedList(event, row) {
        this.builtUpAreas$.pipe(take(1)).subscribe(measurements => {
            measurements.forEach(item => {
                if (item.id == row.id) {
                    item.selected = event.checked;
                    if (item.selected) {
                        this.selection.select(item); // Select item in selection model
                    }
                    else {
                        this.selection.deselect(item);
                    }
                }
            });

            this.isAllSelectedCheckBox = !measurements.some(a => !a.selected)

        });


    }

    selectAll(event: any) {
        const checked = event.checked;
        this.builtUpAreas$.pipe(take(1)).subscribe((measurements: any[]) => {
            measurements.forEach((measurement) => {
                measurement.selected = checked;
            });
        });
    }
    checkboxLabel() {
        if (this.isAllSelected()) {
            return 'Deselect all';
        }
        if (this.selection.isEmpty()) {
            return 'Select all';
        }
        return `${this.selection.selected.length} selected`;
    }

    isAllSelected() {
        // Check if all measurements are selected
        return this.builtUpAreas$.pipe(
            take(1),
            map(measurements => measurements.every(measurement => measurement.selected))
        );
    }


    toggleAllRows() {
        this.isAllSelected().subscribe(allSelected => {
            if (!allSelected) {
                // Select all items
                this.builtUpAreas$.pipe(take(1)).subscribe(measurements => {
                    measurements.forEach(item => {
                        item.selected = true;
                        this.selection.select(item); // Select item in selection model
                    });
                });
                this.isAllSelectedCheckBox = true;
            } else {
                // Deselect all items
                this.builtUpAreas$.pipe(take(1)).subscribe(measurements => {
                    measurements.forEach(item => {
                        item.selected = false;
                        this.selection.deselect(item); // Deselect item in selection model
                    });
                });
                this.isAllSelectedCheckBox = false;
            }
        });
    }

    onClose() {
        const returnValue = {
            // populate with your form data or any other data
            total : this.total
        }
        this._matDialogRef.close(returnValue);
}
}
